interface ScorecardAgentsMetricSummary {
    supervisor_number: string;
    scorecard_version_id: number;
    scorecard_name: string;
    total_metrics_attained: number;
    total_agents: number;
    scorecard_calculation_rule_id?: number;
}

interface TierAttainmentSummary {
    scorecard_version_id: number;
    scorecard_name: string;
    attainment_label: string;
    attainment_rank: number;
    total_agents: number;
}

const getLabelsFromChartData = (pieChartData: ScorecardAgentsMetricSummary[] | undefined) => {
    const lables = pieChartData?.map((item: ScorecardAgentsMetricSummary) => {
        const metric = item?.total_metrics_attained > 1 ? 'Metrics' : 'Metric';
        const agent = item?.total_agents > 1 ? 'Agents' : 'Agent';
        return `${item?.total_metrics_attained} ${metric} - ${item.total_agents} ${agent}`;
    });

    return lables ?? [];
};

const getChartDataSets = (pieChartData: ScorecardAgentsMetricSummary[] | undefined) => {
    const chartData = pieChartData?.map((item: ScorecardAgentsMetricSummary) => {
        return item?.total_agents;
    });

    return chartData ?? [];
};

export const optionsChartMetrics = (pieChartData: ScorecardAgentsMetricSummary[] | undefined) => {
    const chartDataSets = getChartDataSets(pieChartData);
    const chartLabels = getLabelsFromChartData(pieChartData);

    return {
        labels: chartLabels,
        legend: {
            show: true,
            markers: { width: 15, height: 8, radius: 5 },
            fontSize: '12px',
            position: 'bottom',
        },
        responsive: [{ breakpoint: 1600, options: { width: '100%', height: '100%', legend: { position: 'bottom' } } }],
        plotOptions: { pie: { expandOnClick: true, dataLabels: { offset: -8, minAngleToShowLabel: 15 } } },
        colors: ['#50cd89', '#0ff7d8', '#f7d040', '#ddf740', '#f74040'],
        tooltip: {
            y: {
                formatter: (val: any) => {
                    const labelText = val > 1 ? val + ' Agents' : val + ' Agent';
                    const total = chartDataSets.reduce((sum: number, v: number) => sum + v, 0);
                    const percentText = total > 0 ? ` -- ${((val / total) * 100).toFixed(2)} %` : '';
                    return `${labelText}${percentText}`;
                },
                title: { formatter: () => '' },
            },
        },
        dataLabels: {
            formatter: (val: any) => val > 10 ? val.toFixed(2) + ' %' : '',
            dropShadow: { enabled: false },
            textAnchor: 'middle',
            style: { fontWeight: 'bold', fontSize: '12px', colors: ['#ffffff', '#000000', '#000000', '#000000', '#ffffff'] },
            forecastDataPoints: { count: 0, fillOpacity: 0.5, strokeWidth: 0, dashArray: 4 },
        },
        datasets: [{ data: chartDataSets, label: 'Hello', fill: false, backgroundColor: ['#50cd89', '#0ff7d8', '#f7d040', '#ddf740', '#f74040'], hoverBackgroundColor: ['#50cd89', '#0ff7d8', '#f7d040', '#ddf740', '#f74040'] }],
    };
};

export const optionsChartMetricsTier = (tierData: TierAttainmentSummary[] | undefined) => {
    const total = tierData?.reduce((sum, item) => sum + item.total_agents, 0) ?? 1;
    const labels = tierData?.map((item) => {
        const pct = total > 0 ? Math.round((item.total_agents / total) * 100) : 0;
        return `${pct}% - ${item.attainment_label ?? 'No Data'}`;
    }) ?? [];
    const colors = tierData?.map((item) => {
        if (item.attainment_rank === 2) return '#2AA154'; // Exceeds — dark green
        if (item.attainment_rank === 1) return '#3768E8'; // Meets — TTEC blue
        if (item.attainment_rank === 0) return '#E23636'; // Below Meets — fail red
        return '#6c757d';
    }) ?? ['#2AA154', '#3768E8', '#E23636'];

    return {
        labels,
        legend: {
            show: true,
            markers: {
                width: 10,
                height: 10,
                radius: 5,
                shape: 'circle',
            },
            fontSize: '12px',
            position: 'bottom',
        },
        responsive: [{ breakpoint: 1600, options: { width: '100%', height: '100%', legend: { position: 'bottom' } } }],
        plotOptions: {
            pie: {
                expandOnClick: true,
                dataLabels: { offset: -8, minAngleToShowLabel: 15 },
            },
        },
        stroke: {
            show: false,
        },
        colors,
        tooltip: {
            y: {
                formatter: (val: any) => {
                    const labelText = val > 1 ? val + ' Agents' : val + ' Agent';
                    const percentText = total > 0 ? ` -- ${((val / total) * 100).toFixed(2)} %` : '';
                    return `${labelText}${percentText}`;
                },
                title: { formatter: () => '' },
            },
        },
        dataLabels: {
            formatter: (val: any) => val > 10 ? val.toFixed(2) + ' %' : '',
            dropShadow: { enabled: false },
            textAnchor: 'middle',
            style: { fontWeight: 'bold', fontSize: '12px', colors: ['#ffffff', '#ffffff', '#ffffff'] },
        },
    };
};
